import { NearMeOutlined, PlaceOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import AddressForm from '../../Shared/AddressForm.jsx';


export default function AddressesDetails({ sender, setSender, recipient, setRecipient, hasSenderSelected, hasRecipientSelected, setValidatedAddresses }) {
  useEffect(() => {
    let validated = true
    const textRegex = /^\s*$/

    if (hasSenderSelected === false) {
      if (textRegex.test(sender?.nombre) || sender?.nombre === undefined) {
        validated = false
      }

      if (textRegex.test(sender?.apellidoPaterno) || sender?.apellidoPaterno === undefined) {
        validated = false
      }

      if (textRegex.test(sender?.telefono1) || sender?.telefono1 === undefined) {
        validated = false
      }

      if (textRegex.test(sender?.calle) || sender?.calle === undefined) {
        validated = false
      }

      if (textRegex.test(sender?.numeroExterior) || sender?.numeroExterior === undefined) {
        validated = false
      }

      if (textRegex.test(sender?.colonia) || sender?.colonia === undefined) {
        validated = false
      }

      if (textRegex.test(sender?.municipio) || sender?.municipio === undefined) {
        validated = false
      }

      if (textRegex.test(sender?.estado) || sender?.estado === undefined) {
        validated = false
      }

      if (textRegex.test(sender?.pais) || sender?.pais === undefined) {
        validated = false
      }
    }

    if (hasRecipientSelected === false) {
      if (textRegex.test(recipient?.nombre) || recipient?.nombre === undefined) {
        validated = false
      }

      if (textRegex.test(recipient?.apellidoPaterno) || recipient?.apellidoPaterno === undefined) {
        validated = false
      }

      if (textRegex.test(recipient?.telefono1) || recipient?.telefono1 === undefined) {
        validated = false
      }

      if (textRegex.test(recipient?.calle) || recipient?.calle === undefined) {
        validated = false
      }

      if (textRegex.test(recipient?.numeroExterior) || recipient?.numeroExterior === undefined) {
        validated = false
      }

      if (textRegex.test(recipient?.colonia) || recipient?.colonia === undefined) {
        validated = false
      }

      if (textRegex.test(recipient?.municipio) || recipient?.municipio === undefined) {
        validated = false
      }

      if (textRegex.test(recipient?.estado) || recipient?.estado === undefined) {
        validated = false
      }

      if (textRegex.test(recipient?.pais) || recipient?.pais === undefined) {
        validated = false
      }
    }
    
    setValidatedAddresses(validated)
  }, [sender, recipient])

  return (
    <Stack spacing={2}>
      <Typography variant='body1'>A continuación, ingresa los detalles de los domicilios que hacen falta</Typography>

      <AddressForm
        getter={sender}
        setter={setSender}
        icon={<PlaceOutlined sx={{ fontSize: 18 }} />}
        title='Detalles del origen'
      />

      <AddressForm
        getter={recipient}
        setter={setRecipient}
        icon={<NearMeOutlined sx={{ fontSize: 18 }} />}
        title='Detalles del destino'
      />
    </Stack>
  )
}

function filtrarCaracteres(texto) {
  let textoNormalizado = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  // Same accepted class as Shared/AddressForm.jsx: keep '.', '-', '#', '/', ',' so
  // an address like "km 3.5" reads back exactly as it was stored.
  return textoNormalizado.replace(/[^a-zA-Z0-9 .#/,-]/g, '');
}
